import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAtomValue, useSetAtom } from 'jotai';
import api from '@/data/api';
import Toast from '@/utils/toastManager';
import PdfPreview from '@/TRC/components/PdfPreview';
import PdfViewer from '@/TRC/components/PdfView';
import CommonContent from '@/TRC/components/CommonContent';
import VideoReaction from '@/Pages/VideoPlayer/components/VideoReaction';
import VideoTags from '@/Pages/VideoPlayer/components/VideoTags';
import { videoHasTags } from '@/utils/checkTags';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { userReactionAtom } from '@/data/atoms/reactionAtom';
import '@/Pages/VideoPlayer/PlayerPage.css';
import './LessonPlanDetail.css';

const LessonPlanDetail = () => {
	const [content, setContent] = useState(null);
	const [pdfView, setPdfView] = useState(false);
	const { id } = useParams();
	const navigate = useNavigate();
	const userData = useAtomValue(userInfoAtom);
	const setReactionMap = useSetAtom(userReactionAtom);

	useEffect(() => {
		async function fetch() {
			try {
				const response = await api.getLessonPlanById(id);
				setContent(response?.data);
			} catch (err) {
				Toast.error(err.message || 'Failed to fetch lesson plan');
			}
		}
		fetch();
	}, [id]);

	useEffect(() => {
		if (!userData?.user?.userId) return;
		api.getUserReactionsApi(userData.user.userId).then(res => {
			const reactions = res?.data || [];
			setReactionMap(prev => {
				const updated = { ...prev };
				reactions.forEach(r => { updated[r.videoId] = r.reaction; });
				return updated;
			});
		}).catch(() => {});
	}, [userData?.user?.userId]);

	return (
		<div className="d-flex flex-column gap-2">
			{pdfView ? (
				<>
					<div className="pdf-viewer-wrapper">
						<PdfViewer fileUrl={content?.fileUrl} onClose={() => setPdfView(false)} />
					</div>
					<div className="trc-description-container">
						<div className="c-video_description">
							<div>
								<div className="c-video_description-h4">
									<h1>{content?.title}</h1>
									<VideoReaction videoId={content?._id} type="lesson-plan" />
								</div>
								<div className="c-video_description-tag_trc d-flex gap-2 align-items-start">
									{videoHasTags(content) && <VideoTags tags={content?.tagsDetails} type="trc" />}
									{content?.pages && <span className="c-video_description-tag-span text-white">{content.pages} pages</span>}
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<PdfPreview content={content} setPdfView={setPdfView} />
			)}
			<CommonContent type="pdf" content={content} />
		</div>
	);
};

export default LessonPlanDetail;
